import {
  ACTIVATE_SELECT_ALL,
  ADD_ASYNC,
  CHANGE_COMPLIANCE_REPORT_DATA,
  CLEAR_COMPLIANCE_REPORT_DATA,
  CREATE_COMPLIANCE_REPORT_ASYNC,
  DATA_REQUEST_ASYNC,
  FETCH_MANAGEMENT_TAGS_ASYNC,
  FETCH_PROFILES_SUGGESTIONS_ASYNC,
  PAGINATE_CHANGE,
  PROTECTED_FILTER_CHANGE,
  RISK_LEVELS_FILTER_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SEGMENTS_FILTER_CHANGE,
  SET_MANAGEMENT_TAGS_PAGE,
  SET_MANAGEMENT_TAGS_SEARCH,
  SORT_PROPERTY_CHANGE,
  STATUSES_TOGGLE_ASYNC,
  TAGS_FILTER_CHANGE,
  TYPE_FILTER_CHANGE,
} from './constants'

export const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
const addMailbox = () => ({ type: ADD_ASYNC.INITIATE })
const addMailboxCancel = () => ({ type: ADD_ASYNC.CANCEL })
const statusesToggle = (status) => ({
  type: STATUSES_TOGGLE_ASYNC.INITIATE,
  payload: { status },
})
const statusesToggleCancel = () => ({ type: STATUSES_TOGGLE_ASYNC.CANCEL })
export const statusesToggleSuccess = (data) => ({
  type: STATUSES_TOGGLE_ASYNC.SUCCESS,
  payload: { data },
})
export const statusesToggleError = (error) => ({
  type: STATUSES_TOGGLE_ASYNC.ERROR,
  error,
})
const sortPropertyChange = (value) => ({
  type: SORT_PROPERTY_CHANGE,
  payload: { value },
})
const typeFilterChange = (value) => ({
  type: TYPE_FILTER_CHANGE,
  payload: { value },
})
const protectedFilterChange = (value) => ({
  type: PROTECTED_FILTER_CHANGE,
  payload: { value },
})
const tagsFilterChange = (selectedTagsArray) => ({
  type: TAGS_FILTER_CHANGE,
  payload: { selectedTagsArray },
})
const segmentsFilterChange = (selectedSegmentsArray) => ({
  type: SEGMENTS_FILTER_CHANGE,
  payload: { selectedSegmentsArray },
})
const riskLevelFilterChange = (selectedRiskLevelsArray) => ({
  type: RISK_LEVELS_FILTER_CHANGE,
  payload: { selectedRiskLevelsArray },
})
const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })
const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })
const activateSelectAll = () => ({ type: ACTIVATE_SELECT_ALL })
const clearComplianceReportData = () => ({ type: CLEAR_COMPLIANCE_REPORT_DATA })
const changeComplianceReportData = (fieldName, value) => ({
  type: CHANGE_COMPLIANCE_REPORT_DATA,
  payload: { fieldName, value },
})

const fetchProfilesSuggestions = (search) => ({
  type: FETCH_PROFILES_SUGGESTIONS_ASYNC.INITIATE,
  payload: { search },
})
export const fetchProfilesSuggestionsSuccess = (data) => ({
  type: FETCH_PROFILES_SUGGESTIONS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchProfilesSuggestionsError = (error) => ({
  type: FETCH_PROFILES_SUGGESTIONS_ASYNC.ERROR,
  error,
})
const fetchProfilesSuggestionsCancel = () => ({
  type: FETCH_PROFILES_SUGGESTIONS_ASYNC.CANCEL,
})

const createComplianceReport = () => ({
  type: CREATE_COMPLIANCE_REPORT_ASYNC.INITIATE,
})
export const createComplianceReportSuccess = () => ({
  type: CREATE_COMPLIANCE_REPORT_ASYNC.SUCCESS,
})
export const createComplianceReportError = (error) => ({
  type: CREATE_COMPLIANCE_REPORT_ASYNC.ERROR,
  error,
})
const createComplianceReportCancel = () => ({
  type: CREATE_COMPLIANCE_REPORT_ASYNC.CANCEL,
})

export const fetchManagementTags = () => ({
  type: FETCH_MANAGEMENT_TAGS_ASYNC.INITIATE,
})
const fetchManagementTagsCancel = () => ({ type: FETCH_MANAGEMENT_TAGS_ASYNC.CANCEL })
export const fetchManagementTagsSuccess = (data) => ({
  type: FETCH_MANAGEMENT_TAGS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchManagementTagsError = (error) => ({
  type: FETCH_MANAGEMENT_TAGS_ASYNC.ERROR,
  error,
})
const setManagementTagsPage = (page) => ({
  type: SET_MANAGEMENT_TAGS_PAGE,
  payload: { page },
})
const setManagementTagsSearch = (search) => ({
  type: SET_MANAGEMENT_TAGS_SEARCH,
  payload: { search },
})

export default {
  // to props
  fetchData,
  fetchDataCancel,
  sortPropertyChange,
  addMailbox,
  addMailboxCancel,
  statusesToggle,
  statusesToggleCancel,
  typeFilterChange,
  protectedFilterChange,
  tagsFilterChange,
  segmentsFilterChange,
  riskLevelFilterChange,
  paginateChange,
  searchChange,
  searchReset,
  activateSelectAll,
  fetchProfilesSuggestions,
  fetchProfilesSuggestionsCancel,
  changeComplianceReportData,
  clearComplianceReportData,
  createComplianceReport,
  createComplianceReportCancel,
  fetchManagementTags,
  fetchManagementTagsCancel,
  fetchManagementTagsSuccess,
  fetchManagementTagsError,
  setManagementTagsPage,
  setManagementTagsSearch,
}
